define('gigaset_recurring/classes/provider/billwerk/steps/review',[
	"jquery",
	"lodash",
	"./_abstract",
	"cartware/jquery/bem",
	"cartware/components/Logger",
	"cartware/components/Config"
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Logger,
	Config
) {

	function ReviewStep() {
		AbstractStep.call(this);
		this.logger = Logger.getLogger("gigaset_recurring/review");
	}

	ReviewStep.prototype = _.create(new AbstractStep, {
		constructor: ReviewStep,
		_displayInSidebar: false,

		initialize: function() {
			this.block = BEM.block("gigaset-recurring-checkout-review");
			this.tableBlock = BEM.block("checkout-review-table");
			this.proceedButton	= this.block.getElements("proceed-button");
			this.backButton		= this.block.getElements("back-button");
			this.reviewSlot		= this.block.getElements("review-slot");
			this.reviewTmpl		= _.template(this.block.getElements("tmpl-review").html());
			this.rowTmpl		= _.template(this.block.getElements("tmpl-review-row").html());
			this.reviewItemImage	= this.block.getElements("tmpl-review-item-image").html();
			this.intervalTmpl	= _.template(this.block.getElements("tmpl-review-item-interval").html());
			this.trialPeriodTmpl		= _.template(this.block.getElements("tmpl-trial-period").html());
			this.reviewItemDescription = _.template(this.block.getElements("tmpl-review-item-info").html());

			this.nextBillingTmpl		= _.template(this.block.getElements("tmpl-next-billing").html());
			this.contractPeriodTmpl		= _.template(this.block.getElements("tmpl-contract-period").html());
			this.periodTmpl				= _.template(this.block.getElements("tmpl-period").html());

			this.cartIntervalTmpl		= _.template(BEM.block("gigaset-recurring-cart").getElements("tmpl-cart-item-interval").html());
			this.cartTotalsTmpl			= _.template(this.block.getElements("tmpl-review-totals").html());
			// this.totalsBlock			= this.tableBlock.getElements("review-totals");

			this.agreementsBlock = BEM.block("checkout-agreements");

			this.bindEvents();
			this.render();
		},

		render: function () {
			var self = this;
			var data = this.getData("preview"),
				priceFormat = this.getData("priceFormat");

			var trialPeriod = _.get(data, 'Order.TrialPeriod');

			var shippingCosts =  _.reduce(
				_.filter(
					_.get(data, 'Order.RatedItems', []),
					function(item) {
						return /^SHIPPING\|/.match(_.get(item, 'Description', ''));
					}
				),
				function(result, item) {
					return result + _.get(item, 'TotalGross');
				},
				0
			);

			var contractPeriod = _.get(this.getData("plan"), 'ContractPeriod');

			var endAfterFirstContractPeriod = _.get(this.getData("plan"), 'EndAfterFirstContractPeriod');

			if (contractPeriod) {
				contractPeriod.endAfterFirstContractPeriod = endAfterFirstContractPeriod;
			}

			var nextBillingDateFormatted = Config.get('recurring.provider.billwerk.order.preview.next_total_gross_date_formatted');

			var html = this.reviewTmpl({
				Order: data.Order,
				shippingCosts: shippingCosts,
				totals: this.getData("totals"),
				reviewItemImage: this.reviewItemImage,
				reviewItemDescription: this.reviewItemDescription({
					recurringInterval: endAfterFirstContractPeriod
						? ''
						: (this.intervalTmpl(data.Order.RecurringFee.FeePeriod)),
					trialPeriod: trialPeriod ? ('<br/>' + this.trialPeriodTmpl(trialPeriod)) : '',
					contractPeriod: contractPeriod ? (this.contractPeriodTmpl(contractPeriod) + '<br/>') : '',
					nextBillingDate: endAfterFirstContractPeriod
						? ''
						: ('<br />' + this.nextBillingTmpl({date: nextBillingDateFormatted}))
				}),
				nextBillingDateFormatted: nextBillingDateFormatted,
				renderTotals: this.cartTotalsTmpl,
				renderRow: this.rowTmpl,
				renderInterval: function(period) {
					return self.cartIntervalTmpl(period);
				},
				renderPrice: function(price) {
					return formatCurrency(price, priceFormat);
				},
				renderPeriod: function(period) {
					return self.periodTmpl(period);
				},
				renderInterval: this.intervalTmpl
			});

			this.reviewSlot.html(html);
		},

		bindEvents: function() {
			this.proceedButton.on("click", _.bind(this.submit, this));
			this.backButton.on("click", _.bind(this.previous, this));
			this.getData("module").on("preview.reloaded", _.bind(this.render, this));
			this.getData("module").on("order.create", _.bind(this.onOrderCreate, this));
			this.getData("module").on("order.fail", _.bind(this.onOrderFail, this));
			this.getData("module").on("updateBlocks", _.bind(this.updateBlocks, this));
		},

		updateBlocks: function(blocks) {
			var render = false;

			if ("review_totals" in blocks) {
				// this.cartTotalsTmpl =  _.template(blocks["review_totals"]);
				this.tableBlock.getElements("review-totals").replaceWith(blocks["review_totals"]);
				render = true;
			}
			// render && this.render();
		},

		onOrderCreate: function() {
			this.proceedButton.button("loading");
		},

		onOrderFail: function() {
			this.proceedButton.button("reset");
		},

		open: function() {
			this.logger.info("review", this.getFormData());
			this.proceedButton.button("reset");
			return AbstractStep.prototype.open.apply(this, arguments);
		},

		validate: function() {
			var checkboxes = this.agreementsBlock.find('input[type="checkbox"]')
			var valid = checkboxes.length === checkboxes.filter(":checked").length;

			if (!valid) {
				this.emit("validationError", "Please agree to all Terms and Conditions before placing the order.");
				return false;
			}

			var module = this.getData("module"),
				url = _.get(module, "validateQuoteUrl"),
				dfd = $.Deferred();

			if (!url) {
				return valid;
			}

			this.proceedButton.button("loading");

			$.post(url)
				.always(_.bind(function() {
					this.proceedButton.button("reset");
				}, this))
				.done(_.bind(function() {
					dfd.resolve();
				}, this))
				.fail(_.bind(function(xhr) {
					var error = xhr.responseJSON;
					var message = _.get(error, 'message', module.translate("Quote is invalid"));

					var url = _.get(error, 'url');
					if (url) {
						this.getData("module").once("modal.close", function() {
							window.location.href = url;
						});
					}

					this.logger.error("Quote is invalid", error);
					module.handleError(new Error("Quote is invalid"), message);
					dfd.reject();
				}, this));

			return dfd.promise();
		}
	});

	return ReviewStep;

});
